module.exports = __webpack_public_path__ + "img/ssdds.fda9a59f.png";